import "../Main.scss";
import "./Certified.scss";
import Sub from "../Sub";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState, createContext } from "react";
import axios from "axios";
import jwtDecode from "jwt-decode";
import Institution from "./Institution";
import Authinfo from "./Authinfo";
import Swal from "sweetalert2";
import ConfirmModal from "../../components/ConfirmModal";

export const MyContext = createContext();
function Certified() {
  const location = useLocation();
  let navigate = useNavigate();
  const { state } = useLocation();
  const [btnName, setBtnName] = useState("");
  const [certData, setCertData] = useState([]);
  const [prevData, setPrevData] = useState([]);

  const getCertData = async () => {
    try {
      const response = await axios.get("/api/apply-guide", {
        params: {
          notState: 0,
          targetId: state.id[0].workflowId,
        },
      });
      setBtnName(response.data.data[0].targetName);
      setCertData(response.data.data[0].body);
    } catch (err) {
      console.log(err);
    }
  };
  const getPrevData = async () => {
    try {
      const response = await axios.get("/api/apply-proc", {
        params: {
          taskGroupId: state.id[0].id,
          state: 0,
        },

        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      setPrevData(response.data.data);
    } catch (err) {
      console.log(err);
    }
  };
  const delPrevData = (e) => async () => {
    try {
      const response = await axios.delete(`/api/apply-proc/${e.id}/temp`);
    } catch (error) {
      console.log(error);
    }
    if (prevData.length === 1) {
      setShowModal(false);
    }
    getPrevData();
  };

  const [showModal, setShowModal] = useState(false);
  const closeModal = () => {
    setShowModal(false);
  };
  const [showModal2, setShowModal2] = useState(false);
  const closeModal2 = () => {
    navigate("/login/userlogin");
    setShowModal2(false);
  };

  const getModalData = () => {
    if (window.sessionStorage.getItem("token") === null) {
      setShowModal2(true);
    } else {
      const decodedToken = jwtDecode(window.sessionStorage.getItem("token"));
      if (decodedToken.obj.memberType.toUpperCase() === "COMMITTEE") {
        return Swal.fire({
          icon: "error",
          title: "오류",
          text: "위원회계정은 신청이 불가합니다",
          confirmButtonColor: "dodgerBlue",
        });
      }
      if (prevData.length > 0) {
        setShowModal(true);
      } else {
        navigate("/request/institution", { state: state });
      }
    }
  };
  const selectPrevData = (e) => async () => {
    const response = await axios.get(`/api/apply-proc/${e.id}`);
    const addedState = state;
    addedState.prevData = response.data;
    navigate("/request/institution", { state: addedState });
  };
  useEffect(() => {
    getPrevData();
    getCertData();
  }, [navigate]);
  return (
    <>
      {showModal ? (
        <div className="popup_bg_bbs" onClick={closeModal}>
          <div
            className="password_change "
            onClick={(e) => e.stopPropagation()}
          >
            <div className="pophead_bbs">
              <h1>임시저장 데이터</h1>
            </div>
            <div className="password_change_inner">
              {prevData.map((e) => {
                return (
                  <table key={e.id} className="table_new_wrap">
                    <tbody>
                      <tr style={{ gap: "1vw" }}>
                        <td
                          className="eid"
                          style={{ width: "500px", fontSize: "0.875rem" }}
                        >
                          <b>
                            {e.createAt.substring(0, 16).replace(/-/g, ".")}
                          </b>
                          <br /> 에 작성된 데이터가있습니다.
                        </td>
                        <td className="eid_btn">
                          <button
                            type="button"
                            onClick={selectPrevData(e)}
                            className="btn_color"
                          >
                            진행
                          </button>
                        </td>
                        <td className="eid_btn">
                          <button
                            type="button"
                            onClick={delPrevData(e)}
                            className="btn_color"
                            style={{ backgroundColor: "red", border: "none" }}
                          >
                            삭제
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                );
              })}
              <div className="btns_wrap">
                <button className="btn_color" onClick={closeModal}>
                  <span className="material-icons">취소</span>
                </button>
                <button
                  className="btn_color"
                  onClick={() => {
                    navigate("/request/institution", { state: state });
                  }}
                >
                  <span className="material-icons">새로진행</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {showModal2 ? (
        <ConfirmModal
          closeModal={closeModal2}
          modalTitle={"로그인"}
          content={`로그인이 필요한 페이지입니다.`}
        />
      ) : null}
      <Sub to={"/certified"} title="인증서비스" />
      <div
        className="contain map_wrap"
        style={{
          padding: "2rem",
        }}
      >
        <div>
          <div
            className="btns_wrap"
            style={{
              justifyContent: "flex-end",
              display: "flex",
            }}
          >
            <button className="btn_color" onClick={getModalData}>
              {btnName}신청
            </button>
          </div>
          <div className="my_page map_contain" style={{ marginTop: "1rem" }}>
            <div
              style={{
                borderRadius: "3px",
                padding: "0px 2rem 2rem 2rem",
                overflow: "auto",
              }}
              className="jodit-wysiwyg"
              dangerouslySetInnerHTML={{ __html: certData }}
            ></div>
          </div>
        </div>
        <div
          className="btns_wrap"
          style={{
            justifyContent: "flex-end",
            display: "flex",
            marginTop: "1rem",
          }}
        >
          <button className="btn_color" onClick={getModalData}>
            {btnName}신청
          </button>
        </div>
      </div>
    </>
  );
}

export default Certified;
